import { render, staticRenderFns } from "./LtkProductLike.vue?vue&type=template&id=6bbe7336&scoped=true"
import script from "./LtkProductLike.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkProductLike.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LtkProductLike.vue?vue&type=style&index=0&id=6bbe7336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbe7336",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CBtnLike: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CBtnLike/CBtnLike.vue').default})
